import {
  ITrainingCenterAddress,
  TrainingCenterAddress
} from './training-center-address.model';
import { ITrainingCenterBusinessHours } from './training-center-business-hours.model';

export interface ITrainingCenter {
  id: string;
  geminiSiteId: string;
  salesforceId: string;
  name: string;
  description: string;
  phoneNumber: string;
  emailAddress: string;
  pictureBlobName: string;
  pictureBlobUrl: string;
  businessHours: ITrainingCenterBusinessHours[];
  address: ITrainingCenterAddress;
}

export class TrainingCenter implements ITrainingCenter {
  id: string;
  geminiSiteId: string;
  salesforceId: string;
  name: string;
  description: string;
  phoneNumber: string;
  emailAddress: string;
  pictureBlobName: string;
  pictureBlobUrl: string;
  businessHours: ITrainingCenterBusinessHours[];
  address: ITrainingCenterAddress;

  constructor(clone: TrainingCenter = null) {
    this.id = '';
    this.geminiSiteId = '';
    this.salesforceId = '';
    this.name = '';
    this.description = '';
    this.phoneNumber = '';
    this.emailAddress = '';
    this.pictureBlobName = '';
    this.pictureBlobUrl = '';
    this.businessHours = [];
    this.address = new TrainingCenterAddress();

    if (clone) {
      this.id = clone.id;
      this.geminiSiteId = clone.geminiSiteId;
      this.salesforceId = clone.salesforceId;
      this.name = clone.name;
      this.description = clone.description;
      this.phoneNumber = clone.phoneNumber;
      this.emailAddress = clone.emailAddress;
      this.pictureBlobName = clone.pictureBlobName;
      this.pictureBlobUrl = clone.pictureBlobUrl;
      this.businessHours = clone.businessHours;
      this.address = clone.address;
    }
  }
}
